export default "__VITE_ASSET__Bq$sMj8a__"